(function(){
  async function init_bg_video(parent){
    $(parent).data("is-inited", true)

    $(parent).find(".t4s-col-item").mouseover(function(){
      $parent = $(this).closest(".t4s-col-item")
      $parent.addClass('is_over')
      // video = $parent.find('.t4s_cover video')[0]
      // is_moveing = $(this).hasClass('mibao-cover-is_moving')
      // // console.log(2222)
      // // $(this).parent().addClass("t4s-postervideo-playing")
      // if(video && video.paused && !is_moveing){
      //   video.play()
      //   // console.log('play')
      // }
      // $(this).removeClass('mibao-cover-is_moving')
    })
    $(parent).find(".t4s-col-item").mouseout(function(){
      $parent = $(this).closest(".t4s-col-item")
      $parent.removeClass('is_over')
      // $parent = $(this).closest(".mibao-item")
      // video = $parent.find('.t4s_cover video')[0]
      // if(video){
      //   video.pause()
      //   // console.log('pause')
      // }
      // $(this).removeClass('mibao-cover-is_moving')
    })

    $(parent).find(".t4s-col-item .mibao-player-button").click(function(){
      $parent = $(this).closest(".t4s-col-item")
      video = $parent.find('.t4s_cover video')[0]
      if(video){
        if(video.paused){
          $parent.addClass('is_playing')
          video.play()
        }else{
          $parent.removeClass('is_playing')
          video.pause()
        }
      }
    })

    // 播放首个视频
    await MB_waitElementReady(".mibao-text-with-video .t4s-col-item video")
    const first_video = $(parent).find(".t4s-col-item video").first()
    if(first_video){
      first_video[0].play()
    }


    const el = $(parent).find(".t4s-flicky-slider")[0]
    await MB_sleep(100)
    const carousel = el.flickityt4s.$carousel
    carousel.on("select.flickityt4s", function (t, index) {
      if(MB_is_mobile()){
        $(parent).find(".t4s-col-item").removeClass('is_over')
        $(parent).find('.t4s-col-item.is-selected').addClass('is_over')
        $(parent).find(".t4s_cover video").each(function(){
          // const is_selected = $(this).closest('.t4s-col-item').hasClass('is-selected')
          // if(is_selected && this.paused){
          //   // await MB_sleep(100)
          //   console.log(22222, this)
          //   this.play()
          // }else{
          //   console.log(2222233333)
          //   // this.pause()
          // }
        })
      }
    });

  }

  async function init(){
    await MB_waitElementReady(".mibao-text-with-video .t4s-col-item .t4s_cover")
    $(".mibao-text-with-video").each(async function(i, el) {
      const is_init = $(el).data("is-inited")
      if(!is_init){
        init_bg_video(el)
      }
      await MB_sleep(100)
    })
  }

  document.addEventListener('DOMContentLoaded', function(){
      // console.log("DOMContentLoaded",'ok')
      // MB_jsDeferHandle(init_bg_video, ['jQuery'])
      MB_jsDeferHandle(init, ['jQuery'])
  })
}())